import Radio from './radio';
import Group from './group';
import Button from './radioButton';
Radio.Button = Button;
Radio.Group = Group;
export { Button, Group };
export default Radio;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/radio/index.js
// module id = 333
// module chunks = 0